import React from 'react';

import classNames from 'classnames';
import { Kbd } from '@ergeon/help-components';
import { MagnifyingGlassIcon } from '@ergeon/icons/hero/mini';

import { getModifierKey } from './keyboard';
import { useWikiPalette } from './WikiPaletteProvider';

const TRIGGER_CLASSES = classNames(
  'flex min-w-0 cursor-pointer items-center rounded-lg border border-gray-300 bg-white text-gray-600',
  'hover:border-gray-400 hover:text-gray-900 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500',
  'dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:border-gray-600 dark:hover:text-white',
  'dark:focus-visible:ring-blue-300',
);

const SIZE_CLASSES = {
  compact: 'h-9 gap-2 px-2.5 paragraph-2',
  large: 'h-14 w-full gap-3 rounded-xl px-4 paragraph-1',
};

const LABEL_CLASSES = {
  compact: 'hidden md:block',
  large: 'block',
};

type PaletteTriggerProps = {
  className?: string;
  label?: string;
  size?: keyof typeof SIZE_CLASSES;
};

const PaletteTrigger = ({ className, label = 'Search the wiki…', size = 'compact' }: PaletteTriggerProps) => {
  const { openPalette } = useWikiPalette();

  return (
    <button
      aria-haspopup="dialog"
      aria-label="Search the wiki"
      className={classNames(TRIGGER_CLASSES, SIZE_CLASSES[size], className)}
      onClick={openPalette}
      type="button">
      <MagnifyingGlassIcon aria-hidden="true" className="size-5 shrink-0" />
      <span className={classNames('min-w-0 flex-1 truncate text-left', LABEL_CLASSES[size])}>{label}</span>
      <span aria-hidden="true" className="hidden shrink-0 items-center gap-1 md:flex">
        <Kbd>{getModifierKey()}</Kbd>
        <Kbd>K</Kbd>
      </span>
    </button>
  );
};

export default PaletteTrigger;
